module.exports = __webpack_public_path__ + "img/drinking_water.6cbd7145.svg";